import api from "../../lib/apiClient";
import { toast } from "sonner";

// Télécharge la facture PDF générée par le backend (CEHN-YYYY-NNNNN). Le PDF exige
// l'en-tête d'authentification : on récupère un blob puis on déclenche le téléchargement.
export async function downloadInvoice(orderId, number) {
  try {
    const res = await api.get(`/marketplace/orders/${orderId}/invoice`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `facture-${number || orderId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    toast.error("Facture indisponible pour cette commande.");
  }
}
